import { useRbTexts } from 'remote-state/applicationHooks';

export default function useTexts() {
  const texts = useRbTexts();
  const componentTexts = {
    templatesListTitle: texts?.['spaces.floatingTicketPanel.header.templatesListTitle'],
    templatesListSearchPlaceholder: texts?.['spaces.floatingTicketPanel.header.templatesListSearchPlaceholder'],
    emptyTicketTitle: texts?.['spaces.floatingTicketPanel.header.emptyTicketTitle'],
    headerTypeText: texts?.['spaces.floatingTicketPanel.header.type'],
    template: texts?.['spaces.floatingTicketPanel.header.template'],
    messageCreatedText: texts?.['spaces.floatingTicketPanel.messages.ticketCreated'],
    failedToCreateTicket: texts?.['spaces.floatingTicketPanel.messages.failedToCreateTicket'],
    areYouSureTitle: texts?.['spaces.floatingTicketPanel.messages.areYouSureTitle'],
    areYouSureBody: texts?.['spaces.floatingTicketPanel.messages.areYouSureBody'],
    areYouSureOk: texts?.['spaces.floatingTicketPanel.messages.areYouSureOk'],
    areYouSureCancel: texts?.['spaces.floatingTicketPanel.messages.areYouSureCancel'],
    cancelButtonText: texts?.['spaces.floatingTicketPanel.buttons.cancel'] || 'Cancel',
    createButtonText: texts?.['spaces.floatingTicketPanel.buttons.create'] || 'Create',
    incidentText: texts?.['spaces.srType.incident'],
    problemText: texts?.['spaces.srType.problem'],
    requestText: texts?.['spaces.srType.request'],
    changeText: texts?.['spaces.srType.change'],
    viewSR: texts?.['spaces.floatingTicketPanel.messages.viewSR'],
  };

  return componentTexts;
}
